import React from "react";
import { useTranslation } from "react-i18next";
import { PMDialog } from "../../utils/PMDialog";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

export const HourRegistrationWarningDialog = ({
  open,
  onClose,
  onConfirm,
  activityTitle,
  estimatedHours,
  registeredHours,
  newHours,
  totalAfterRegistration,
}) => {
  const { t } = useTranslation();

  return (
    <PMDialog
      open={open}
      onClose={onClose}
      title={t("hours.registration_warning.title")}
    >
      <div className="mt-4">
        <div className="flex items-start space-x-3">
          <ExclamationTriangleIcon className="h-6 w-6 text-yellow-600 flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm text-gray-700 mb-4">
              {t("hours.registration_warning.message", {
                activityTitle: activityTitle || t("hours.registration_warning.this_activity"),
                estimatedHours: estimatedHours?.toFixed(2) || "0,00",
                registeredHours: registeredHours?.toFixed(2) || "0,00",
                newHours: newHours?.toFixed(2) || "0,00",
                totalAfterRegistration: totalAfterRegistration?.toFixed(2) || "0,00",
              })}
            </p>
            <p className="text-sm font-medium text-gray-900 mb-2">
              {t("hours.registration_warning.question")}
            </p>
          </div>
        </div>

        <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
          <button
            type="button"
            className="inline-flex justify-center w-full rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
            onClick={onClose}
          >
            {t("hours.registration_warning.cancel")}
          </button>

          <button
            type="button"
            className="inline-flex justify-center w-full rounded-md border border-transparent bg-yellow-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 sm:text-sm"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {t("hours.registration_warning.confirm")}
          </button>
        </div>
      </div>
    </PMDialog>
  );
};

